import { render, staticRenderFns } from "./RecommendedItemsTable.vue?vue&type=template&id=36114ae4&scoped=true&"
import script from "./RecommendedItemsTable.vue?vue&type=script&lang=js&"
export * from "./RecommendedItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36114ae4",
  null
  
)

export default component.exports